import React, { useState } from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';
import PropTypes from 'prop-types';

import './styles.scss';

import { Icon } from '../../ui-kit';

const Gallery = (props) => {
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  const createNewArrayForGallery = (photos) => {
    const newArray = [];
    for (let i = 0; i < photos.length; i += 1) {
      newArray.push({ src: photos[i].uri });
    }
    return newArray;
  };

  const renderImages = () => createNewArrayForGallery(props.photos).map((source, j) => (
    <div
      onClick={() => {
        setCurrentImageIndex(j);
        setLightboxIsOpen(true);
      }}
      key={source.src}
      className="gallery_item__block"
    >
      <img alt="user_picture" src={source.src} />
      <button
        type="button"
        onClick={
          (e) => {
            e.stopPropagation(); 
            props.handleConfirmOpen(j, props.castingId, props.photos);
          }
        }
      >
        <Icon name="clear" color='#FFF' />
      </button>
    </div>
  ));

  return (
    <>
      <div className="gallery_block">
        {props.photos ? renderImages() : ''}
      </div>
      {lightboxIsOpen ? (
        <ModalGateway>
          <Modal onClose={() => setLightboxIsOpen(false)}>
            <Carousel
              currentIndex={currentImageIndex}
              views={createNewArrayForGallery(props.photos)}
            />
          </Modal>
        </ModalGateway>
      ) : null}
    </>
  );
};

Gallery.propTypes = {
  photos: PropTypes.array,
  handleConfirmOpen: PropTypes.func,
};
Gallery.defaultProps = {
  photos: [],
  handleConfirmOpen: () => {},
};

export default Gallery;
